import { App } from './app.class';
import { Fetch } from '../fetch.class';
import { Notification } from './notification.class';

export class Page {

    constructor() {

        // Elemente
        const $panelContainer = document.getElementById('panel-container');
        const $panelEmail = document.getElementById('panel-email');
        const $panelForm = document.getElementById('panel-form');
        const $btnBack = $panelForm.querySelector('a.back');

        // Event: Absenden der Email-Adresse
        $panelEmail.addEventListener('submit', event => {
            event.preventDefault();

            // Sendebutton deaktivieren
            App.setSubmitBtnLoading($panelEmail);

            // Übermittlung
            const formData = new FormData($panelEmail);
            new Fetch().post(App.getUrl('create-endpoint', 'validate_email'), formData)
            .then(response => {

                // Fehlermeldung ausblenden
                const $otherErrorbox = $panelForm.querySelector('.errorbox');
                $otherErrorbox.classList.add('hidden');

                // zur Formulareingabe
                $panelEmail.classList.add('hidden');
                App.animateCSS($panelForm, 'swoopInRight');
                $panelForm.classList.remove('hidden');
            })
            .catch(error => {

                const $errorbox = $panelEmail.querySelector('.errorbox');
                const $cont = $errorbox.querySelector('.cont');
                const $cont_exists = $errorbox.querySelector('.cont_exists');
                $errorbox.classList.remove('hidden');

                // Account bereits vorhanden
                if(error.message == "exists") {
                    $cont.classList.add('hidden');
                    $cont_exists.classList.remove('hidden');
                }

                // Fehlermeldung anzeigen
                else {
                    $cont.classList.remove('hidden');
                    $cont_exists.classList.add('hidden');
                    $cont.innerHTML = error.message;
                    App.animateCSS($errorbox, 'pullUp');
                }

                // Box schütteln
                App.animateCSS($panelContainer, 'shake');
            })
            .finally(() => {

                // Sendebutton zurücksetzen
                App.setSubmitBtnActive($panelEmail);
            });
        });

        // Event: Zurück
        $btnBack.addEventListener('click', event => {
            event.preventDefault();

            // Fehlermeldung ausblenden
            $panelEmail.querySelector('.errorbox').classList.add('hidden');

            // Email-Eingabe einblenden
            $panelForm.classList.add('hidden');
            App.animateCSS($panelEmail, 'swoopInLeft');
            $panelEmail.classList.remove('hidden');
        });

        // Event: Einrichten
        $panelForm.addEventListener('submit', event => {
            event.preventDefault();

            // Sendebutton deaktivieren
            App.setSubmitBtnLoading($panelForm);

            // Übermittlung
            const formData = new FormData($panelForm);
            const $emailField = $panelEmail.querySelector("#email");
            formData.append("email", $emailField.value);
            new Fetch().post(App.getUrl('create-endpoint', 'create'), formData)
            .then(response => {

                // Weiterleitung zur Integration
                App.goto('form', 'installation', response.form_code);
            })
            .catch(error => {

                const $errorbox = $panelForm.querySelector('.errorbox');
                const $cont = $errorbox.querySelector('.cont');
                $errorbox.classList.remove('hidden');

                // Fehlermeldung anzeigen
                $cont.classList.remove('hidden');
                $cont.innerHTML = error.message;
                App.animateCSS($errorbox, 'pullUp');

                // Box schütteln
                App.animateCSS($panelContainer, 'shake');
            })
            .finally(() => {

                // Sendebutton zurücksetzen
                App.setSubmitBtnActive($panelForm);
            });
        });

    }
}

// Initialisierung wenn DOM geladen
App.domready(() => {
    if(document.querySelector('body').classList.contains('create-endpoint')) {
        new Page();
    }
});